import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import bgImage from "../../assets/images/img11.png";
import TypingText from "../utils/TypingText";

const achievements = [
  {
    number: "01",
    title: "Youngest Pakistani",
    description: "The youngest mountaineer to summit all 14×8000ers.",
  },
  {
    number: "02",
    title: "Hilal-e-Imtiaz",
    description: "One of Pakistan’s highest civilian honors.",
  },
  {
    number: "03",
    title: "Guinness World Record",
    description:
      "Youngest person to summit K2 & Everest and youngest to complete 14×8000ers.",
  },
  {
    number: "04",
    title: "Acclaimed Mountaineer",
    description:
      "Recognized worldwide for historic summits and groundbreaking mountaineering.",
  },
];

export default function AchievementsAccordion() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section
      className="relative w-full text-white py-28 overflow-hidden bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black/30 z-0"></div>

        {/* WATERMARK HEADER */}
      <div className="relative flex flex-col items-center justify-center mb-14 md:mb-20 select-none pointer-events-none">
    
        {/* BACKGROUND TEXT */}
        <h1
          className="
            font-black text-gray-300/30
            leading-none tracking-tight text-center
            -mb-[clamp(1.5rem,6vw,6rem)]
          "
          style={{ fontSize: "clamp(3rem,16vw,14rem)" }}
        >
          BROADBOY
        </h1>

        {/* FOREGROUND TEXT */}
        <h3
          className="
            font-bold text-white/70 tracking-tight leading-none text-center
            text-[clamp(2rem,10vw,12rem)]
          "
        >
          ACHIEVEMENTS
        </h3>

      </div>

      <div className="relative z-10">
        <p
          className="
            font-light
            mx-[clamp(1.25rem,10vw,16rem)]
            mb-12
            text-center text-[#ffffff]
            text-[clamp(1.1rem,2vw,4rem)] leading-relaxed
          "
        >
          <TypingText
            speed={0.04}
            text="
              By 19, I had
              scaled Everest, and on 9 October 2024, I completed climbing all 14 of
              the world’s 8,000-meter peaks. This journey is more than summits; it's
              about passion, perseverance, and proving that no dream is too big.
            "
          />
        </p>

        {/* CONTENT */}
       <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10 md:px-12">
        <div className="flex flex-col md:flex-row gap-4 md:h-[260px]">
          {achievements.map((item, index) => {
            const isActive = index === activeIndex;

            return (
              <motion.div
                key={item.number}
                layout
                style={{ flex: isActive ? 2.4 : 1 }}
                onHoverStart={() => setActiveIndex(index)}
                onClick={() => setActiveIndex(index)}
                transition={{ type: "spring", stiffness: 240, damping: 26 }}
                className={`
                  group flex border backdrop-blur-md p-6 sm:p-8 rounded-xl
                  overflow-visible min-w-[240px]
                  cursor-pointer border-white/10
                  ${isActive ? "bg-white/10" : "bg-white/5 hover:bg-white/10"}
                `}
              >
                {/* Number */}
                <div className="flex items-center justify-center px-4 py-2 border-r border-white/20">
                  <span className="origin-center -rotate-90 text-sm md:text-lg tracking-[0.25em] text-white/80">
                    {item.number}
                  </span>
                </div>

                {/* Content */}
                <div className="flex flex-col justify-between py-2 pl-5 pr-6 sm:pl-6 sm:pr-8 w-full">
                  
                  {/* TITLE */}
                  <div
                    className="overflow-hidden"
                    style={{
                      minHeight: "clamp(2.6rem, 3.5vw, 4.2rem)", // room for 2 lines
                    }}
                  >
                    <motion.p
                      className="
                        font-bold leading-snug w-full
                        origin-top-left
                        drop-shadow-lg
                        will-change-transform
                      "
                      style={{
                        fontSize: "1.9rem",
                      }}
                      animate={{
                        scale: isActive ? 1 : 0.53,
                        opacity: isActive ? 1 : 0.7,
                        color: isActive ? "#ffffff" : "rgba(255,255,255,0.7)",
                        fontWeight: isActive ? 700 : 300,
                      }}
                      transition={{
                        scale: {
                          type: "spring",
                          stiffness: isActive ? 260 : 200,
                          damping: isActive ? 30 : 34,
                        },
                        opacity: { duration: 0.2 },
                        color: { duration: 0.2 },
                      }}
                    >
                      {item.title}
                    </motion.p>
                  </div>

                  {/* DESCRIPTION */}
        
                    <motion.div
                      layout
                      initial={false}
                      animate={{
                        height: isActive ? "auto" : 0,
                        opacity: isActive ? 1 : 0,
                        y: isActive ? 0 : 6,
                      }}
                      transition={{
                        height: { duration: 0.35, ease: "easeInOut" },
                        opacity: { duration: 0.2 },
                      }}
                      className="overflow-hidden"
                    >
                      <p className="text-[13px] sm:text-sm text-gray-200 max-w-sm mt-2">
                        {item.description}
                      </p>
                    </motion.div>

                  {/* DIVIDER */}
                  <motion.div
                    layout
                    className="h-[1px] w-full mt-3"
                    animate={{
                      backgroundColor: "rgba(255,255,255,0.7)",
                      opacity: isActive ? 1 : 0.3,
                    }}
                    transition={{ duration: 0.25 }}
                  />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      </div>
    </section>
  );
}
